import { memo } from 'react';

import { type Board } from '@air/api/types';

import { useSetPrivateFiltersFromContextToRedux } from '~/hooks/filters/useSetPrivateFiltersFromContextToRedux';

export type PrivateFiltersReduxObserverProps = {
  boardId?: Board['id'];
};

export const PrivateFiltersReduxObserver = memo(({ boardId }: PrivateFiltersReduxObserverProps) => {
  useSetPrivateFiltersFromContextToRedux(boardId);

  return null;
});

PrivateFiltersReduxObserver.displayName = 'PrivateFiltersReduxObserver';
